// Builds the env_url sent to backend APIs based on the current window location.
// - If the host is an IP address, include the port (e.g. http://100.26.54.253:3030)
// - If the host is a domain, use just the protocol + hostname (e.g. https://robitest.datopic.com)
export const getEnvUrl = () => {
  if (typeof window === 'undefined' || !window.location) return '';

  const { protocol, hostname, host } = window.location;
  const isIpAddress = /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);
  const isLocalhost = hostname === 'localhost';

  // IP / localhost -> keep the port (host); real domain -> hostname only
  return isIpAddress || isLocalhost ? `${protocol}//${host}` : `${protocol}//${hostname}`;
};

export default getEnvUrl;
